<div class="editable-list__input-group">
    <mat-form-field>
        <input 
            matInput
            [matAutocomplete]="auto"
            [formControl]="inputControl"
            [type]="type" 
            [name]="name"
            class="editable-list__input"
            placeholder="{{placeholder}}" 
            autocomplete="{{autocomplete}}"
            (focus)="handleFocus($event)" 
            (blur)="handleBlur()" 
            [required]="required"
        >

        <mat-autocomplete #auto="matAutocomplete" [disableRipple]="true">
            <mat-option *ngFor="let suggestion of (suggestions || [])" [value]="suggestion" (onSelectionChange)="onSelectionChange($event)" (click)="onSelectionClick($event)">
                {{ suggestion }}
            </mat-option>
        </mat-autocomplete>

    </mat-form-field>
    <div [hidden]="!(inputControl?.invalid && (inputControl?.dirty || inputControl?.touched))">
        <div class="editable-list__input-error-message" [hidden]="!(inputControl?.errors && inputControl?.errors?.required)">Please fill out this field.</div>
    </div>
</div>
